import { Checkbox } from 'antd';
import { requestMedicalRecords } from '../../../../api/requestMedicalRecords';
import {
    AddRecordsBtV2,
    LastUpdatedRefreshStrip,
    RequestRecordsBt,
} from '../../../../pages/MedicalRecordsRightPanel';
import { MedicalHistory, uploadIcon } from '../../../common/Icons';
import {
    FETCH_STATE,
    LoaderWithText,
    RefreshWithErrorText,
} from '../../../common/PatientOverviewUtils';

const MedicalRecordsEmpty: React.FC<{
    ptId: string;
    onComplete: () => void;
    lastUpdated: string;
    showNavbar?: boolean;
    onClickRequestRecordsBt: () => void;
    hideActionCTAs?: boolean;
    fetchState?: FETCH_STATE;
    onRefresh?: () => void;
}> = ({
    ptId,
    onComplete,
    lastUpdated,
    showNavbar = true,
    onClickRequestRecordsBt,
    hideActionCTAs,
    fetchState,
    onRefresh,
}) => {
    return (
        <div className="flex flex-col rounded-8 font-lato bg-white w-full h-full pb-16">
            {showNavbar && (
                <NavBar
                    ptId={ptId}
                    onComplete={onComplete}
                    lastUpdated={lastUpdated}
                    onClickRequestRecordsBt={onClickRequestRecordsBt}
                    hideActionCTAs={hideActionCTAs}
                />
            )}

            <div className="pb-20 flex-1 grid place-content-center">
                <div className="w-240 h-176 overflow-hidden">
                    <img src="/images/Records.png" alt="medical records" className="w-full" />
                </div>
                <p className="text-center my-16 font-700 text-14 h-24">
                    {fetchState === FETCH_STATE.FETCHING ? (
                        <LoaderWithText text="Fetching medical records" />
                    ) : fetchState === FETCH_STATE.ERROR ? (
                        <RefreshWithErrorText
                            text="Error in Fetching medical records"
                            onRefresh={onRefresh}
                        />
                    ) : (
                        'No medical records added!'
                    )}
                </p>
                {!hideActionCTAs && (
                    <AddRecordsBtV2
                        ptId={ptId}
                        onComplete={onComplete}
                        icon={mrUploadIcon}
                        text="Upload medical records"
                        from="medical-records-empty"
                    />
                )}
                {/* <RequestRecordsBt
                    text="Request from Patient"
                    className="font-700 text-darwin-primary-500 mt-18 m-auto"
                    onClick={onClickRequestRecordsBt}
                /> */}
            </div>
        </div>
    );
};

const medicalHistoryIcon = MedicalHistory('fill-neutral-0');
const mrUploadIcon = uploadIcon('fill-darwin-primary-500');

export const NavBar: React.FC<{
    onComplete: () => void;
    lastUpdated: string;
    ptId: string;
    isButtonVisible?: boolean;
    diffCount?: number;
    profileFilter?: 'profile' | 'all';
    onProfileFilterChange?: (profile: 'profile' | 'all') => void;
    onClickRequestRecordsBt: () => void;
    hideActionCTAs?: boolean;
}> = ({
    lastUpdated,
    ptId,
    onComplete,
    isButtonVisible = false,
    diffCount,
    profileFilter,
    onProfileFilterChange,
    onClickRequestRecordsBt,
    hideActionCTAs,
}) => {
    return (
        <div className="border-b bg-white border-darwin-neutral-100 flex items-center rounded-t-8 justify-between flex-wrap px-12 py-7">
            <div className="flex items-center">
                <div className="w-24 h-24 flex justify-center items-center rounded-4 bg-darwin-accent-sulphur-green-500">
                    {medicalHistoryIcon}
                </div>
                <p className="ml-8 mr-12 font-700 text-14">Medical Records</p>
                {!hideActionCTAs && (
                    <LastUpdatedRefreshStrip lastUpdated={lastUpdated} onRefresh={onComplete} />
                )}
                {!hideActionCTAs &&
                diffCount &&
                diffCount > 0 &&
                onProfileFilterChange &&
                profileFilter ? (
                    <div className="p-8 secondary-btn select-none ml-16">
                        <Checkbox
                            onChange={(e) =>
                                onProfileFilterChange(e.target.checked ? 'all' : 'profile')
                            }
                            checked={profileFilter === 'all'}
                        >
                            +{diffCount} records from other profiles
                        </Checkbox>
                    </div>
                ) : null}
            </div>

            {isButtonVisible && (
                <div className="flex items-center space-x-20">
                    {/* <RequestRecordsBt
                        text="Request"
                        className="m-auto"
                        onClick={onClickRequestRecordsBt}
                    /> */}

                    {!hideActionCTAs && (
                        <AddRecordsBtV2
                            ptId={ptId}
                            onComplete={onComplete}
                            icon={mrUploadIcon}
                            cssClass={'flex items-center space-x-8'}
                            text="Upload"
                            from="medical-records-navbar"
                        />
                    )}
                </div>
            )}
        </div>
    );
};

export default MedicalRecordsEmpty;
